import { useEffect, useRef, useState } from "react";
import { getAgencyLeadCount, updateDashboardAgencyLeadCount } from '@src/store/slices/insurance';
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from '@src/config/constant';

const Notifaction = () => {
   
    const dispatch: any = useDispatch();
    const insurance = useSelector((state: any) => state.insurance)
    const [leadCount, setLeadClount] = useState(insurance?.agencyLeadCountDashboard || 0);

    const eventSourceRef = useRef<EventSource | null>(null);
    const reconnectTimerRef = useRef<NodeJS.Timeout | null>(null);

    const connect = () => {
        if (eventSourceRef.current) {
          eventSourceRef.current.close();
        }
    
        function getAgencyCount() {
            dispatch(getAgencyLeadCount())
        }
        
        const es = new EventSource(`${API_URL.GETWAY_API}userAdminAuth/fetchIncomingLeadsCount`);
        eventSourceRef.current = es;

         //WAIT FEW SEC TO CALL API 
        let timeOut = setTimeout(()=>{
            getAgencyCount()
        },10000)
    
        es.onopen = () => {
          // console.log("SSE connected");
        };
    
        es.onmessage = (event) => {
            const data = JSON.parse(event.data);
            // console.log("datadata", data)
            setLeadClount(data);
            dispatch(updateDashboardAgencyLeadCount(data))
        };
    
        es.onerror = (e) => {
          // console.error("SSE error:", e);
          es.close();
          clearTimeout(timeOut)

          // Try to reconnect after 10s
          reconnectTimerRef.current = setTimeout(() => {
            // console.log("Reconnecting SSE...");
            connect();
          }, 10000);
        };
      };
    
      /*useEffect(() => {
        //connect();
    
        return () => {
          eventSourceRef.current?.close();
          if (reconnectTimerRef.current) clearTimeout(reconnectTimerRef.current);
        };// eslint-disable-next-line
      }, []); */


    return (
        <div className={"dropdown"}>
            <button
                className=""
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                >
                <i className="ic-notification"></i>
                <span className="notification-count">
                    {+leadCount > 999 ? '999+' : leadCount}
                </span>
            </button>
            
        </div>

    );
}

export default Notifaction;
